export const FETCH_USER = 'fetch_user';
export const FETCH_SITES = 'fetch_sites';
export const PAGES_RAW = 'pages_raw';
export const PAGES_SEARCH = 'pages_search';
export const PAGE_LOADING = 'page_loading';
export const QUERY_LOADING = 'query_loading';
export const START_DATE = 'start_date';
export const END_DATE = 'end_date';
export const FOCUSED_INPUT = 'focused_input';
export const QUERIES = 'queries';
export const QUERIES_PAGINATED = 'queries_paginated';
export const IS_PAGE_ACTIVE = 'is_page_active';
export const FETCH_PAGE_METRICS_BY_DATE = 'fetch_page_metrics_by_date';
export const SELECT_METRIC = 'select_metric';
export const SELECTED_PAGE = 'selected_page';
export const FETCH_QUERY_METRICS_BY_DATE = 'fetch_query_metrics_by_date';
export const SELECTED_QUERY = 'selected_query';
export const IS_QUERY_ACTIVE = 'is_query_active';
export const PAGE_COUNT = 'page_count';
export const QUERIES_COUNT = 'queries_count';
export const POSITION_FILTER = 'position_filter';
export const ACTIVE_QUERY_PAGE_NUM = 'active_query_page_num';
export const IS_CHECKED = 'is_checked';
export const COUNTRY_LIST = 'country_list';
export const DEVICE_LIST = 'device_list';
export const SELECTED_COUNTRY = 'selected_country';
export const TITLE_TAG = 'title_tag';
export const URL = 'url';
export const META_DESCRIPTION = 'meta_description';
export const PAGE_META = 'page_meta';
export const SELECTED_SITE = 'selected_site';
export const ERROR = 'error';
export const H1 = 'h1';
export const KEYWORD_DENSITY = 'keyword_density';
export const OCCURRENCE = 'occurrence';
export const QUERIES_FIVE_W = 'queries_five_w';
export const QUERIES_FIVE_W_TOGGLE = 'queries_five_w_toggle';
export const TITLE_COPY = 'title_copy';
export const DESC_COPY = 'desc_copy';
export const H1_COPY = 'h1_copy';
export const COPY_RESET = 'copy_reset';
export const TITLE_LEN = 'title_len';
export const META_DESC_LEN = 'meta_desc_len';
export const DEVICE = 'device';
export const ACTIVE_PAGE_NUM = 'active_page_num';
export const CONNECTION = 'connection';
export const PAGE_SORT_METRIC = 'page_sort_metric';
export const QUERY_SORT_METRIC = 'query_sort_metric';
export const PAGE_ORDER_DIRECTION = 'page_order_direction';
export const QUERY_ORDER_DIRECTION = 'query_order_direction';
export const QUERIES_RAW = 'queries_raw';
export const QUERIES_SORT = 'queries_sort';
export const KEYWORD_VOLUME = 'keyword_volume';
export const DATE_PRESET = 'date_preset';
export const CHART_TOGGLE = 'chart_toggle';
export const ADMIN_USERS_TO_ADD = 'admin_users_to_add';
export const ADMIN_USERS_TO_REMOVE = 'admin_users_to_remove';
export const EXPORT_LOADING = 'export_loading';
export const EXPORT_DATA = 'export_data';
export const PAYMENT_CONFIRMATION = 'payment_confirmation';
export const UNSUBSCRIBE_CONFIRMATION = 'unsubscribe_confirmation';



// WEBPACK FOOTER //
// ./src/actions/types.js